module.exports = __webpack_public_path__ + "img/Celloger Nano.739f3ddd.png";